import { withRouter } from 'react-router-dom';
import SubSubNavBar from './SubSubNavBar';

export default withRouter(SubSubNavBar);

export type { SubSubNavBarItem } from './types';
